<template>
	<ConversionForm :strategyList="strategyList">
		<el-col :span="24" class="col-h" v-if="global.isPosition">
			<el-row class="row-box"  >
				<span class="border-title">三阶出价</span>
						<div v-for="item in global.appList" :key="item.value" class=" row-box-item" >
							<p class="app_name text-color-normal">{{ item.app_name }}</p>
						<el-col  
							:span="27"
						>
							<el-form-item label="转化名称"  required>
								<el-select 
									v-model="formData[`deep_${item.value}`]" :disabled="!formData[item.value]"
									@change="()=>handleChangeDeepName(`type_${item.value}`)"
								>
									<el-option 
										v-for="item in ( global.cacheDeepConversionName[formData[item.value]] || [] )" 
										:label="item.label" :key="item.value" 
										:value="item.value"
									/>
								</el-select>
							</el-form-item>
						</el-col>
						<el-col  
							:span="24"
						>
							<el-form-item label="转化类型"   required >
								<el-select 
									v-model="formData[`type_${item.value}`]" 
									:disabled="!formData[`deep_${item.value}`]"
								>
									<el-option 
										v-for="item in ( deepOptimizeType[[item.value]] || [] )" 
										:label="item.label" :key="item.value" 
										:value="item.value"
									/>
								</el-select>
							</el-form-item>
						</el-col>
					</div>
				<!-- {{ item.app_name }} -->
				
			</el-row>
		</el-col>
		<template v-else>
			<el-col :span="7" class="col-h" >
				<el-form-item label="深度转化名称"  required>
						<el-select 
							v-model="formData.deepName" 
							:disabled="!formData.target"
							@change="()=>handleChangeDeepName('deepType')"
						>
							<el-option 
								v-for="item in ( global.cacheDeepConversionName[formData.target] || [] )" 
								:label="item.label" :key="item.value" 
								:value="item.value"
							/>
						</el-select>
					</el-form-item>
			</el-col>
			<el-col :span="7" class="col-h">
				<el-form-item label="深度优化类型"  >
					<el-select v-model="formData.deepType"  :disabled="!formData.deepName"> 
						<el-option 
							v-for="item in (deepOptimizeType || [])" 
							:label="item.label" 
							:value="item.value"
							:key="item.value"
						/>
					</el-select>
				</el-form-item>
			</el-col>
		</template>
		
		<template slot="top">
			<el-col :span="7" class="col-h">
				<el-form-item label="深度转化出价"  :rules="moneyRules">
					<el-input 
						v-model="formData.deepCost" 
						placeholder="请输入价格" @input="(value)=>handleInput('deepCost', value)" 
					/>
				</el-form-item>
				<div class="form-item__tip" v-if="priceAvg">
					<TipInfo :data="priceAvg"/>
				</div>
			</el-col>
		</template>
	</ConversionForm>
</template>

<script>
import { numStrip } from '@/utils'
import ConversionForm from './conversionForm.vue'
import _ from 'lodash';
import TipInfo from './tipInfo'
export default {
    inject: [ 'global' , 'formData', 'moneyRules'],
	props: {
		strategyList: {
			type: Array,
			default: () => null,
		},
	},
	components: { ConversionForm , TipInfo},
	computed: {
		
		conversionNameForm() {
			return this.global.appList.reduce((pre, item)=> {
				pre[item.value] = this.formData[item.value]
				return pre
			}, {})
		},
		// 深度优化类型
		deepOptimizeType () {
			const list = this.global.config.deep_optimize_type;
			if( !this.global.isPosition ) {
				const deepNames = this.global.cacheDeepConversionName[this.formData.target];
				const data = _.find(deepNames, { value: this.formData.deepName  });
				return data ?  list.filter((v)=> v.pid == data.param_id) : [];;
			}
			return this.global.appList.reduce((pre, item)=> {
				const key = `deep_${item.value}`
				const nameId = this.formData[key]; 
				const deepNames = this.global.cacheDeepConversionName[this.formData[item.value]];
				const data = _.find(deepNames, { value: nameId })
				pre[item.value] = data ?  list.filter((v)=> v.pid == data.param_id) : [];
				return pre
			}, {})
		}

	},
    data() {
        return {
            rules: {},
			priceAvg: '', // 出价均值
        }
    },
	methods: {
		handleChangeDeepName (key) {
			this.$set(this.formData, key, '');
			this.avgValue(this.formData.deepCost);
		},
		handleInput(key, value) {
			const num = this.global.handleValidNumber(value);
			if (num) {
				this.formData[key] = num;
			}
			this.avgValue(this.formData[key]);
		},
		async avgValue(value) {
			const { isPosition, appList } = this.global;
			if(!value) {
				return
			}
			const params = {
				price_type: this.formData.way,
				ocpc_strategy: this.formData.strategy,
				// tracking_id: !isPosition? [this.formData.target] : appList.map(item=> this.formData[item.value]),
				deep_effect_target: !isPosition? [this.formData.deepName] : appList.map(item=> this.formData[ `deep_${item.value}`]) 
			};
			if(!isPosition && !this.formData.deepName) {
				return
			}else if(isPosition && !appList.every(item=> this.formData[`deep_${item.value}`])) {
				return
			}
			const result = await this.global.getBatchConversionPrice(params);
			if(!result.deep_effect_price_avg) {
				this.priceAvg = '';
				return
			}
			const n = numStrip(value - result.deep_effect_price_avg);
			if (n>0) {
				this.priceAvg = `高${n}`;
			}else if(n === 0) {
				this.priceAvg = `${n}`;
			}else {
				this.priceAvg = `低${-n}`;
			}
		}
	},
	watch: {
		
		conversionNameForm: {
			handler (n, o) {
				if(_.isEqual(n, o)) {
					return;
				}
				const data = _.omitBy(n, (k)=>o&&o[k]);
				_.keys(data).forEach((v)=> {
					if (!data[v]) {
						return;
					}	
					this.global.getDeepConversionName({
						tracking_id: data[v],
					})
				})
			},
			immediate: true,
		},
		'formData.target': {
			handler (n, o) {
				if(n && n !== o) {
					
					this.global.getDeepConversionName({
						tracking_id: n,
					})
				}
			},
			immediate: true,
		}
	}
}
</script>

<style lang="scss" scoped>
.row-box {
	border: 1px solid #dcdfe6;
	margin: 0 12px 20px;
	border-radius: 8px;
	padding-top: 20px;
	position: relative;
	display: flex;
	flex-wrap: wrap;
	.app_name {
		margin-top: 10px;
		padding-left: 39px;
	}
	&-item {
		background: #f5f5f5;
		border-radius: 6px;
		overflow: hidden;
		margin: 0 20px 20px;
		width: calc(50% - 40px);
	}
}
.border-title {
	position: absolute;
	top: -8px;
	left: 20px;
	color: #606266;
	background: #fff;
}
.form-item__tip {
	margin-top: -16px;
	margin-left: 100px;
	color: #666;
	font-size: 12px;
}
</style>